/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useState } from 'react';

import { jsx } from '@atlaskit/css';

import type { FocusAskLinkData } from '../../types';

import { FocusAskLinksSection } from './FocusAskLinksSection';

type Props = {
	links: FocusAskLinkData[];
	onChange: (links: FocusAskLinkData[]) => void;
};

export const LinksField = ({ links, onChange }: Props): JSX.Element => {
	const [isEditorOpen, setIsEditorOpen] = useState(false);

	return (
		<FocusAskLinksSection
			links={links}
			onChange={onChange}
			isEditorOpen={isEditorOpen}
			onEditorOpenChange={setIsEditorOpen}
		/>
	);
};
